export class ApiRequestError extends Error {
  response: Response;

  /**
   * The parsed error payload, when the response carried JSON. Callers that need more
   * than the message — a machine-readable reason, say — read it from here rather than
   * re-reading the response body.
   */
  body?: unknown;

  constructor(message: string, response: Response, body?: unknown) {
    super(message);
    this.response = response;
    this.body = body;
  }
}
